/* eslint-disable no-return-await */
import { Modal, ModalBody, ModalFooter, Button } from '@zoom/components';
import { TFunction } from 'i18next';
import React from 'react';

import { Prompt } from './Prompt';

interface BlockPromptProps {
  t: TFunction;
  when: boolean;
  onSave: (callback: { proceed: () => void; close: () => void }) => Promise<void>;
  onLeave?: () => Promise<void>;
}

export const PromptModal: React.FC<BlockPromptProps> = ({ t, when, onSave, onLeave }) => (
  <Prompt when={when}>
    {({ onConfirm, onClose }) => (
      <Modal show settings={{ locale: { rtl: 'en' } }}>
        <ModalBody>{t('layout.unsavedModal.body')}</ModalBody>
        <ModalFooter className="justify-content-between">
          <div>
            <Button kind="secondary" onClick={async () => await onSave({ proceed: onConfirm, close: onClose })}>
              {t('layout.unsavedModal.button.submitClose')}
            </Button>
            <Button
              kind="danger"
              outline
              onClick={async () => {
                if (onLeave) {
                  await onLeave();
                }

                onConfirm();
              }}
            >
              {t('layout.unsavedModal.button.submit')}
            </Button>
          </div>
          <div>
            <Button kind="link" onClick={onClose}>
              {t('layout.action.cancel')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    )}
  </Prompt>
);
